import { EdgeDeleteAnnouncementRepository } from '@/modules/connect/infra'
import type { DeleteAnnouncement } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeDeleteAnnouncement(): DeleteAnnouncement {
  return new EdgeDeleteAnnouncementRepository(makeSupabaseEdgeHttpClient()).execute
}
